<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />
        <translator
            v-if="baseDocument"
            :base-document="baseDocument"
            :document-type="documentType"
            :language="form.language"
        ></translator>

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-text
            name="url"
            label="Official Website"
            class="mt-3"
            v-model="form.url"
            :error="errors.url ? errors.url[0] : null"
            :maxlength="255"
        />

        <media-reference
            :language="form.language"
            v-model="form.photo"
            class="mt-3"
            label="Software Logo"
            name="photo_id"
            :media-types="['Image', 'SoftwareLogo']"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "SoftwareForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                url: this.getFormData('url'),
                photo: this.getFormData("photo"),
                photo_id: this.getFormData("photo_id"),
            },
        };
    },
    watch: {
        "form.photo": function(newValue){
            this.form.photo_id = newValue ? newValue.id : null;
        },
    }
};
</script>
